import React from "react"
import styled from "styled-components"
import { Img } from "wordsby-components"

export default function Hero(props) {
  const { bg, alt } = props
  return (
    <Container {...props}>
      <BgImg field={bg} alt={alt} />
    </Container>
  )
}

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(
      0,
      0,
      0,
      ${props => (!!props.darkness ? props.darkness : 0.15)}
    );
    opacity: ${props => (!props.overlay ? 0 : 1)};
  }
`
const BgImg = styled(Img)`
  height: 100%;
  width: 100%;
`
